module.exports = __webpack_public_path__ + "img/3.dace83c7.png";